import clsx from "clsx"
import { FC } from "react"
import { HomeBgImg, LogoBigImg } from "@/assets"
import styles from "./Loader.module.scss"
import { LoaderBar } from "./ui/LoaderBar/LoaderBar"

export const Loader: FC = () => {
  return (
    <div className={clsx(styles.Loader)}>
      <img src={HomeBgImg} alt="background" className={styles.Loader_bg} />
      <img src={LogoBigImg} alt="logo" className={styles.Loader_logo} />
      <LoaderBar />
    </div>
  )
}
